<dp-message-error *ngIf="error && !loadingUser"></dp-message-error>

<dp-card class="form-optin">
    <div class="form-optin__content">
        <dp-loading *ngIf="submitting || loadingUser" text="Por favor, aguarde..."></dp-loading>

        <div *ngIf="!submitting && !loadingUser && !error">
        <!-- <div> -->
            <div class="confirm-information">
                <h2 class="form-optin__title">
                    Confirme as informações abaixo, para acessar e alterar seus dados:
                </h2>
                <p class="text-mute">
                    Nós da Serasa, levamos muito a sério a proteção de seus dados.<br />
                    Para que você tenha acesso às suas informações, precisaremos verificar se você é você mesmo :)<br />
                </p>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
                <div class="form-optin__section">
                    <strong class="form-optin__fieldset">Informações Pessoais</strong>

                    <div class="row">
                        <div class="form-group col-md-6">
                            <label>Nome completo</label>
                            <input spellcheck="false"class="form-control" [value]="userData.fullName | titlecase" [disabled]="true" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-md-6">
                            <label>CPF</label>
                            <input spellcheck="false"class="form-control" [value]="userData.document | cpfMAsk" [disabled]="true" />
                        </div>

                        <div class="form-group col-md-6">
                            <label>Data de nascimento</label>
                            <input spellcheck="false"class="form-control" [value]="userData.birthdate | date: 'dd/MM/yyyy'" [disabled]="true" />
                        </div>

                        <div class="form-group col-md-6">
                            <label>E-mail</label>
                            <input spellcheck="false"class="form-control" [value]="userData.email" [disabled]="true" />
                        </div>

                        <div class="form-group col-md-6" *ngIf="userData.phone">
                            <label>Celular</label>
                            <input spellcheck="false"class="form-control" [value]="userData.phone | PhoneMask" [disabled]="true" />
                        </div>
                    </div>

                    <small class="text-muted"
                        >Não concorda com as informações acima? Caso queira alterá-las,
                        <a class="text-secondary" href="javascript:;" (click)="showLeavePage()">clique aqui</a>.</small
                    >
                </div>

                <div class="form-optin__section">
                    <strong class="form-optin__fieldset-doc">Documentos</strong>
                    <div class="form-optin__document-list">
                        <p>
                            Para verificarmos sua identidade, precisaremos de:
                        </p>
                        <ul>
                            <li>Fotos frente e verso do seu <b>documento com CPF</b> (preferencialmente RG ou CNH):</li>
                            <li>Uma foto sua <b>(selfie) segurando seu documento</b> de identificação ao lado do seu rosto.</li>
                        </ul>
                    </div>

                    <dp-form-images (changefile)="onChangeFile($event)"></dp-form-images>
                </div>

                <div>
                    <div>
                        <dp-button
                            class="d-block"
                            variant="secondary"
                            [title]="submitting ? 'Processando...' : 'Enviar informações'"
                            [type]="'submit'"
                            [disabled]="form.invalid || submitting"
                            [size]="'lg'"
                            [full]="true"
                        ></dp-button>
                    </div>
                    <p class="form-optin__footer">
                      <dp-button-certificate id="certificate-lnk" text="aqui.">
                          <b>Possui Certificado Digital?</b> Acesse seu cadastro
                      </dp-button-certificate>
                  </p>
                </div>
            </form>
        </div>
    </div>
</dp-card>

<dp-modal-box #modal [(show)]="showModal" (onclose)="clearModal()">
    <div class="text-center pb-3">
        <div *ngIf="success">
            <dp-icon-svg name="check"></dp-icon-svg>

            <h3>
                <b>Tudo certo!</b> Seus dados foram enviados para análise e, em até 48 horas, você poderá acompanhar suas informações.
            </h3>

            <p>
                Fique atento à Caixa de Entrada do e-mail cadastrado, pois enviaremos para você um e-mail sobre o andamento da sua
                solicitação.
            </p>

            <dp-button
                id="btn-life-proof-confirm"
                class="my-4"
                size="xl"
                [title]="'Continuar'"
                style="min-width: 200px"
                (click)="confirmSuccessLandingPage(); modal.close()"
            ></dp-button>
        </div>

        <div *ngIf="leavePage">
            <dp-icon-svg name="key"></dp-icon-svg>
            <h3>
                Manter suas informações atualizadas é muito importante!
            </h3>

            <p>
                Para realizar essa alteração, você precisará voltar ao site do Serasa Consumidor. Mas pode deixar que redirecionamos
                você :)
            </p>

            <div class="btn-group my-5">
                <dp-button id="btn-life-proof-back" variant="outline-primary" size="xl" [title]="'Voltar'" (click)="modal.close()"> </dp-button>
                <dp-button id="btn-life-proof-confirm-leave" size="xl" [title]="'Continuar'" (click)="confirmLeavePage()"> </dp-button>
            </div>
        </div>

        <div *ngIf="error">
            <dp-icon-svg name="error"></dp-icon-svg>
            <h3><b>Poxa, algo deu errado!</b> Infelizmente não foi possível aprovar sua solicitação de comprovação de dados.</h3>

            <p>
                Caso tenha dúvidas sobre a comprovação de dados, acesse nosso canal de Dúvidas Frequentes.
                <a class="text-secondary" [href]="'redirect.faq'" rel="noopener" target="_blank">Clique aqui</a>
            </p>

            <div class="btn-group my-5">
                <dp-button id="btn-life-proof-continue" size="xl" [title]="'Continuar'" (click)="confirmError(); modal.close()"> </dp-button>
            </div>
        </div>
    </div>
</dp-modal-box>
